module.exports = __webpack_public_path__ + "static/img/ios1.2.1575519b.jpg";